import SideBar from "../../components/navigation/SideBar";
import { useNavigate } from "react-router-dom";
import { useCreateAthleteMutation, useCreateCoachMutation } from "../../store";
import { authHeaders } from "../../store/authToken";
import StandardForm from "../../components/forms/StandardForm";
import { useState } from "react";
import { useCoach } from "../../hooks/useCoach";

function CreateCoachForm(){
  const navigate = useNavigate();
  const { coach } = useCoach();
  const [createCoach] = useCreateCoachMutation();
  const [selectedRole, setSelectedRole] = useState({
    "id": 1,
    "value": "coach",
    "label": "Coach"
  })
  const onHandleRoleChange = (e)=> {
    setSelectedRole(e);
  }

  const meta = {
      object: "Coach",
      action: "Create new Coach",
      description: "Create a new coach record.",
    };
  
  let config = [
    {
      id:'name',
      label: 'Name',
      type: 'shortText',
      placeholder: 'John Doe',
      size: 2
    },
    {
      id:'email',
      label: 'Email',
      type: 'shortText',
      placeholder: 'johndoe@gmail.com',
      size: 2
    },
    {
      id:'role',
      label: 'Role',
      type: 'dropdown',
      placeholder: 'Choose role',
      options: [
        { id: 1, value: 'coach', label: 'Coach' },
        { id: 2, value: 'admin', label: 'Admin' },
      ],
      size: 2,
      onChange: onHandleRoleChange,
    }
  ];
  
  const handleCreate = async (e) => {
    e.preventDefault();
  
    const submitData = config.reduce((o, input) => {
      let value;
      if (input.id === "role") {
        value = selectedRole.value;
      } else {
        value = e.target.elements[input.id]?.value || "";
      }
      return { ...o, [input.id]: value };
    }, {});
  
    try {
      // Paso 1: crear el usuario de Supabase Auth para el email del coach. El
      // coach entra por magic link; el password no se usa nunca, pero create-user
      // lo exige, así que generamos uno aleatorio fuerte.
      const randomPassword = `${crypto.randomUUID()}Aa1!`;
      const res = await fetch("/api/create-user", {
        method: "POST",
        headers: authHeaders({ "Content-Type": "application/json" }),
        body: JSON.stringify({ email: submitData.email, password: randomPassword }),
      });

      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.error || "Error creando el usuario de acceso");
      }

      // Emparejamiento coach ↔ usuario Supabase por email (no se guarda authId).
      // Paso 2: Crear el coach en tu backend
      await createCoach(submitData);
      navigate("/coaches");
    } catch (error) {
      console.error("Error creando coach:", error);
      alert("Hubo un error al crear el coach. Inténtalo de nuevo.");
    }
  };
  

  return (
    <>
    <div>
      <SideBar/>
      <main className="py-10 lg:pl-72">
        <div className="px-4 sm:px-6 lg:px-8">
          <StandardForm meta={meta} config={config} onSubmit={handleCreate}/>
        </div>
      </main>
    </div>
    </>
  );
}

export default CreateCoachForm;